import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HasAccessDirective } from 'src/app/common/directives';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    CardModule,
    ButtonModule,
    ToastModule,
    HasAccessDirective
  ],
  providers: [MessageService],
  template: `
    <div class="p-6 max-w-7xl mx-auto">
      <!-- Header -->
      <div class="mb-8 text-center">
        <h1 class="text-4xl font-bold text-gray-800 mb-4">
          🚀 GIROP Dashboard
        </h1>
      </div>

      <!-- POC: Módulos Migrados -->
      <p-card header="📋 Modulos Migrados" class="mb-6">
        <div class="grid md:grid-cols-4 gap-4">
          <a
            *hasAccess="'ordenes-servicio'"
            routerLink="/ordenes-servicio"
            class="block p-4 bg-purple-50 hover:bg-purple-100 rounded-lg border border-purple-200 transition-colors"
          >
            <div class="text-center">
              <div class="text-3xl mb-2">📋</div>
              <h3 class="font-semibold text-purple-800">Programar Servicios</h3>
              <p class="text-sm text-purple-600 mt-1">
                Consulta y programación de órdenes
              </p>
            </div>
          </a>
          <a
            *hasAccess="'agenda'"
            routerLink="/agenda"
            class="block p-4 bg-green-50 hover:bg-green-100 rounded-lg border border-green-200 transition-colors"
          >
            <div class="text-center">
              <div class="text-3xl mb-2">📅</div>
              <h3 class="font-semibold text-green-800">Administrar Agenda</h3>
              <p class="text-sm text-green-600 mt-1">
                Gestión de citas y calendario
              </p>
            </div>
          </a>
          <a
            *hasAccess="'sin-orientacion-servicios'"
            routerLink="/sin-orientacion-servicios"
            class="block p-4 bg-green-50 hover:bg-green-100 rounded-lg border border-green-200 transition-colors"
          >
            <div class="text-center">
              <div class="text-3xl mb-2">🧭</div>
              <h3 class="font-semibold text-green-800">
                Sin Orientación de Servicios
              </h3>
              <p class="text-sm text-green-600 mt-1">
                Órdenes sin orientación de servicios
              </p>
            </div>
          </a>
          <a
            *hasAccess="'informes-rechazados'"
            routerLink="/informes-rechazados"
            class="block p-4 bg-red-50 hover:bg-red-100 rounded-lg border border-red-200 transition-colors"
          >
            <div class="text-center">
              <div class="text-3xl mb-2">📋</div>
              <h3 class="font-semibold text-red-800">Informes Rechazados</h3>
              <p class="text-sm text-red-600 mt-1">
                Consulta de cumplimientos rechazados
              </p>
            </div>
          </a>
        </div>
      </p-card>

      <p-toast></p-toast>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      code {
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      }
    `
  ]
})
export class DashboardComponent implements OnInit {
  private http = inject(HttpClient);
  private messageService = inject(MessageService);
  private baseUrl = environment.backend.baseUrl;

  loading = false;
  serviciosStatus: 'online' | 'offline' = 'offline';
  agendaStatus: 'online' | 'offline' = 'offline';

  ngOnInit() {
    this.checkAllStatus();
  }

  checkAllStatus() {
    this.loading = true;

    // Check servicios-ms (8080)
    this.http
      .get(`${this.baseUrl}/servicios/catalogos/tipos-empresa`)
      .pipe(catchError(() => of(null)))
      .subscribe((result) => {
        this.serviciosStatus = result ? 'online' : 'offline';
      });

    // Check agenda-ms (8081)
    this.http
      .get(`${this.baseUrl}/agenda/tipos-cita`)
      .pipe(catchError(() => of(null)))
      .subscribe((result) => {
        this.agendaStatus = result ? 'online' : 'offline';
        this.loading = false;

        if (
          this.serviciosStatus === 'offline' ||
          this.agendaStatus === 'offline'
        ) {
          console.warn('Error: Uno o mas backends no estan disponibles');
        } else {
          console.info('Los backends Agenda y Servicios estan disponibles');
        }
      });
  }
}
